
import request from '@/utils/request';
export const getAgentQrcode = (params: any) =>
  request({
    url: 'Agent/qrcode',
    method: 'get',
    params
  });
export const getAgentOrderCount = (params: any) =>
  request({
    url: 'Agent/orderCount',
    method: 'get',
    params
  });
export const getAgentMonthCount = (params: any) =>
  request({
    url: 'Agent/oderMonthCount',
    method: 'get',
    params
  });
export const getAgentCustomerCount = (params: any) =>
  request({
    url: 'Agent/customerCount',
    method: 'get',
    params
  });
export const getAgentCustomerEveryDayCount = (params: any) =>
  request({
    url: 'Agent/customerEveryDayCount',
    method: 'get',
    params
  });
export const getAgentCustomerList = (params: any) =>
  request({
    url: 'Agent/customerList',
    method: 'get',
    params
  });
export function addCUs(data: any) {
  return request({
    url: 'Agent/customer',
    method: 'post',
    data
  });
}
export function addManager(data: any) {
  return request({
    url: 'Agent/admin',
    method: 'post',
    data
  });
}
export function editorManager(data: any) {
  return request({
    url: 'Agent/admin',
    method: 'put',
    data
  });
}
